/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { LoggingService } from '../../logging/logic/logging.service';
import {
  VisibilityRuleService,
  VisibilityRule,
} from '../visibility-rule-service';

/**
 * Visibility Service checks for given Rules if something is visible
 */
@Injectable({
  providedIn: 'root',
})
export class IsOnRestingBreakVisibilityService
  implements VisibilityRuleService
{
  // Public Member
  public readonly name: VisibilityRule = 'isOnRestingBreak';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private clientStateService: ClientStateService
  ) {}

  // VisibilityRuleService
  public isVisible(params: any): boolean {
    return this.clientStateService.theState.getValue().restingBreakActive;
  }

  // Private Functions
}
